import { takeEvery, put, call } from "redux-saga/effects"

// Chat Redux States
import { GET_IMAGE_LIST_DROPDOWN } from "./actionTypes"

//Include Both Helper File with needed methods
import { getImageList } from "../../helpers/rtw_canvas_be_helper"
import { storeImageListDropdown } from "./action"
import Listener from "../../helpers/Listen"

function* getImageListDropDown() {
  try {
    const response = yield call(getImageList)
    console.log("RESPONES", response)
    if (response.data === "") {
      return
    }
    yield put(storeImageListDropdown(response.data))
  } catch (error) {
    console.log(error)
    // yield put(addMessageFail(error));
  }
}

// function* addSheets(params) {
//   try {
//     const files = params.payload.files ?? null
//     const id = params.payload.id
//     const jsonArr = params.payload.jsonCanvas ?? []

//     const formData = new FormData()
//     formData.append(
//       "numberOfPages",
//       params.payload.jsonCanvas ? params.payload.jsonCanvas.length : 1
//     )

//     if (files) {
//       for (let i = 0; i < files.length; i++) {
//         formData.append(`files`, files[i])
//       }
//     }
//     if (jsonArr) {
//       for (let i = 0; i < jsonArr.length; i++) {
//         formData.append(`jsonArray[${i}]`, JSON.stringify(jsonArr[i]))
//       }
//     }
//     const response = yield call(addSheet, { formData, id })
//     if (files) {
//       yield put(storeSheetDatas(response.data))
//     } else {
//       yield put(resetSheetDatas)
//       Listener.emit("back", "success")
//     }
//   } catch (error) {
//     // yield put(addMessageFail(error));
//   }
// }

function* rtwCanvasSaga() {
  yield takeEvery(GET_IMAGE_LIST_DROPDOWN, getImageListDropDown)
}

export default rtwCanvasSaga
